/**
 * Fluidité B2 (P3#30) — les deux listes de lots d'un partenaire (BET…), avec des noms
 * distincts : « Lots à viser » (lots dont il vise les pièces, ex-« Mes lots ») et
 * « Lots à rédiger » (DPGF / CCTP qui lui sont délégués en conception, ex-« Lots
 * confiés »). Données : GET /api/me/ma-semaine › mes_lots (type « lot » ou « cctp »).
 * Utilisé par le tableau de bord partenaire et la page « Ma semaine ».
 */
import { Link } from 'react-router-dom';
import { LOTS_PARTENAIRE } from '../../lib/libelles';
import { lienChantier } from './maSemaine';

function Liste({ titre, lots, vide, testid }) {
  return (
    <div className="border border-[#E0E0DB] bg-white" data-testid={testid}>
      <div className="px-4 py-3 border-b border-[#E0E0DB] flex items-center justify-between">
        <h2 className="text-sm font-bold uppercase tracking-wider text-[#6B6B6B]">{titre}</h2>
        <span className="text-xs text-[#9A9A9A]">{lots.length}</span>
      </div>
      <div className="divide-y divide-[#E0E0DB]">
        {lots.length === 0 && <p className="text-sm text-[#9A9A9A] text-center py-6">{vide}</p>}
        {lots.map((l) => (
          <Link
            key={`${l.type}-${l.chantier_id}-${l.lot_id}`}
            to={l.type === 'cctp' ? lienChantier(l.chantier_id, 'conception') : lienChantier(l.chantier_id, 'visas')}
            className="block px-4 py-3 hover:bg-[#FAFAF9] transition-colors"
          >
            <div className="flex items-start justify-between gap-2">
              <div className="min-w-0">
                <p className="text-sm font-medium text-[#2C2C2C] truncate">
                  {l.type === 'cctp' ? `CCTP — ${l.lot_nom}` : [l.lot_code, l.lot_nom].filter(Boolean).join(' · ')}
                </p>
                <p className="text-xs text-[#6B6B6B] truncate">
                  {l.chantier_name}{l.entreprise_nom ? ` · ${l.entreprise_nom}` : ''}
                </p>
              </div>
              {l.type === 'cctp' ? (
                <span className="text-[10px] uppercase font-semibold px-1.5 py-0.5 bg-[#F5F5F3] text-[#4A4A4A] flex-shrink-0">{l.statut_libelle}</span>
              ) : l.a_viser > 0 ? (
                <span className="text-[10px] uppercase font-semibold px-1.5 py-0.5 bg-[#E3F2FD] text-[#1E3A5F] flex-shrink-0">{l.a_viser} à viser</span>
              ) : null}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export const lotsAViser = (mesLots) => (mesLots || []).filter((l) => l.type !== 'cctp');
export const lotsARediger = (mesLots) => (mesLots || []).filter((l) => l.type === 'cctp');

export default function LotsPartenaire({ mesLots }) {
  const aViser = lotsAViser(mesLots);
  const aRediger = lotsARediger(mesLots);
  return (
    <>
      <Liste titre={LOTS_PARTENAIRE.aViser} lots={aViser} vide="Aucun lot à viser" testid="partenaire-lots-a-viser" />
      {aRediger.length > 0 && (
        <Liste titre={LOTS_PARTENAIRE.aRediger} lots={aRediger} vide="Aucun lot à rédiger" testid="partenaire-lots-a-rediger" />
      )}
    </>
  );
}
